/* diwali26 hero. Drag-to-scroll on the product rail, and the rail nudges itself once on
 * first view so it is obvious it moves. Nothing here is required for the hero to work:
 * without js it is still a native horizontal scroller and every card is a plain link. */
(function () {
  "use strict";

  var hero = document.querySelector("[data-dw26-hero]");
  if (!hero || hero.dataset.dw26Booted) return;
  hero.dataset.dw26Booted = "1";

  var rail = hero.querySelector("[data-dw26-rail]");
  var hint = hero.querySelector("[data-dw26-hint]");
  if (!rail) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // --- drag to scroll ---------------------------------------------------------
  // Pointer events cover mouse, pen and touch. Touch already scrolls natively, so the
  // handlers only take over once a real drag starts and never block a tap on a card.
  var down = false, startX = 0, startScroll = 0, moved = 0;

  rail.addEventListener("pointerdown", function (e) {
    if (e.pointerType === "touch") return;
    down = true;
    moved = 0;
    startX = e.clientX;
    startScroll = rail.scrollLeft;
    rail.classList.add("is-dragging");
  });

  rail.addEventListener("pointermove", function (e) {
    if (!down) return;
    var dx = e.clientX - startX;
    moved = Math.abs(dx);
    rail.scrollLeft = startScroll - dx;
    if (moved > 4) e.preventDefault();
  });

  function endDrag() {
    if (!down) return;
    down = false;
    rail.classList.remove("is-dragging");
  }
  rail.addEventListener("pointerup", endDrag);
  rail.addEventListener("pointercancel", endDrag);
  rail.addEventListener("pointerleave", endDrag);

  // A drag that ends on a card would otherwise follow the link.
  rail.addEventListener("click", function (e) {
    if (moved > 6) {
      e.preventDefault();
      e.stopPropagation();
      moved = 0;
    }
  }, true);

  // --- hide the hint once it has been understood -------------------------------
  rail.addEventListener("scroll", function () {
    if (hint && rail.scrollLeft > 24) hint.classList.add("is-hidden");
  }, { passive: true });

  // --- one nudge on first view --------------------------------------------------
  // Shows that the rail moves without autoplaying it, which would fight the reader.
  if (!reduce && "IntersectionObserver" in window) {
    var nudged = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || nudged) return;
        nudged = true;
        io.disconnect();
        window.setTimeout(function () {
          if (rail.scrollLeft > 0) return;
          rail.scrollTo({ left: 64, behavior: "smooth" });
          window.setTimeout(function () {
            rail.scrollTo({ left: 0, behavior: "smooth" });
          }, 520);
        }, 650);
      });
    }, { threshold: 0.4 });
    io.observe(rail);
  }
})();
